import React, { useState } from "react";
import { SubMenu } from "../../../components/SubMenu/Submenu";
import { Overview } from "cms/components/dashboard/Overview/Overview";
import { SearchTerm } from "../Search";
import "./dashboard.css";


export const CMSDashboard: React.FC = () => {
  const [selectedSubject, setSelectedSubject] = useState<string>("Overview");
  const [hoveredItem, setHoveredItem] = useState<string>("");

  return (
    <div className="cms-dashboard">
      <div className="dashboard-title">
        <h1>Dashboard</h1>
      </div>

      <SubMenu
        menuItems={["Overview"]}
        selectedItem={selectedSubject}
        hoveredItem={hoveredItem}
        setSelectedItem={setSelectedSubject}
        setHoveredItem={setHoveredItem}
      />

      {selectedSubject === "Overview" ? <Overview /> : <SearchTerm />}
    </div>
  );
};
